var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#C6C0CC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.46313H16V0.463135H4V1.46313H1C0.4 1.46313 0 1.86313 0 2.46313V4.86313C0 7.16313 1.7 9.06313 4 9.36313V9.46313C4 12.3631 6 14.7631 8.7 15.3631L8 17.4631H5.7C5.3 17.4631 4.9 17.7631 4.8 18.1631L4 20.4631H16L15.2 18.1631C15.1 17.7631 14.7 17.4631 14.3 17.4631H12L11.3 15.3631C14 14.7631 16 12.3631 16 9.46313V9.36313C18.3 9.06313 20 7.16313 20 4.86313V2.46313C20 1.86313 19.6 1.46313 19 1.46313ZM4 7.36313C2.9 7.06313 2 6.06313 2 4.86313V3.46313H4V7.36313ZM12 10.4631L10 9.36313L8 10.4631L8.5 8.46313L7 6.46313H9.1L10 4.46313L10.9 6.46313H13L11.5 8.46313L12 10.4631ZM18 4.86313C18 6.06313 17.1 7.16313 16 7.36313V3.46313H18V4.86313Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup-icon.5f77dccf.svg";
export { ForwardRef as ReactComponent };